module.exports = __webpack_public_path__ + "img/Review Icon - charcoal.180b8d6e.svg";